/**
 * Score colors for candidate matching
 */

export const SCORE_COLORS = {
  ideal: "#0084C7", // Blue for ideal candidates
  5: "#4E775B", // Dark green
  4: "#48BF78", // Green
  3: "#CFA769", // Yellow/amber
  2: "#CF8070", // Orange
  1: "#BF5864", // Red
  0: "#94A3B8", // Gray
};

// Legacy score 0 color for card views
export const SCORE_COLOR_ZERO_CARD_VIEW = "#000000"; // Black
